if (!Enum) {
    var Enum = {};
}

Enum.PAYMENT_STATUS = {
    PENDING: 'PENDING',
    WAITING_FOR_CONFIRMATION: 'WAITING_FOR_CONFIRMATION',
    COMPLETED: 'COMPLETED',
    CANCELED: 'CANCELED',
    REJECTED: 'REJECTED',
    NEW: 'NEW'
};

Object.freeze(Enum.PAYMENT_STATUS);